<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-bullhorn">
      Campaigns
      <template v-slot:buttons>
        <v-btn :disabled="loading"
               @click.prevent="fetchData"
               class="mr-2">
          <v-icon left>
            {{ loading ? 'fal fa-fw fa-spin fa-spinner' : 'fal fa-fw fa-sync' }}
          </v-icon>
          Refresh
        </v-btn>
        <v-btn v-if="isEmailComposerEnabled"
               :to="{name: `${$root.routePrefix}.send.email`}"
               :disabled="loading || !lists.length"
               color="primary">
          Send emails
        </v-btn>
        <v-btn v-else
               :to="{name: `${$root.routePrefix}.mailcoach.campaign.wizard`}"
               :disabled="loading || !lists.length"
               color="primary">
          Send campaign
        </v-btn>
        <help-dialog v-if="1===2"
                     :dialog="helpDialog">
        </help-dialog>
      </template>
    </PageTitle>

    <v-card>
      <v-card-text v-if="!loading && !lists.length">
        <p class="text-center">
          You need to add contacts to an email list before you can send a campaign.
        </p>
        <p class="text-center">
          <v-btn color="primary"
                 :to="{name: `${$root.routePrefix}.user_contacts.index`}">
            Add contacts to a list
          </v-btn>
        </p>
      </v-card-text>

      <campaigns-table :loading="loading"
                       :campaigns="campaigns">
      </campaigns-table>
    </v-card>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import mailcoachService from '../../services/mailcoachService';
import HelpDialog from '../../components/HelpDialog';
import CampaignsTable from './components/CampaignsTable';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, CampaignsTable, HelpDialog},
  data() {
    return {
      campaigns: [],
      helpDialog: false,
      lists: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isEmailComposerEnabled', // MLD-6403
      'isMember',
      'team',
      'user',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      return Promise.all([
        this.getCampaigns(),
        this.getLists(),
      ])
        .finally(() => {
          this.loading = false;
        })
    },
    getCampaigns() {
      const params = {
        user_id: this.user.id,
      }
      return mailcoachService.getCampaigns(params)
        .then(data => {
          this.campaigns = orderBy(data, ['created_at'], ['desc']);
        })
    },
    getLists() {
      return mailcoachService.getLists()
        .then(data => {
          this.lists = data;
        })
    }
  }
}
</script>
